module.exports = __webpack_public_path__ + "static/max_koshel_photo-203dab9143ab7d421201eb5952602e31.png";